<app-client-task-history-item-title>
  {{ title }}
</app-client-task-history-item-title>
<app-client-task-history-item-body>
  <div class="my-2 h5">{{ submissionTitle }}</div>

  @if (isReferralTask) {
    <div>
      @switch (clientTaskHistoryItem.data.choice) {
        @case (clientReferralTaskChoices.yes) {
          <div class="ps-3">
            <dl>
              <dt>Supporting documentation type:</dt>
              <dd>
                @if (clientTaskHistoryItem.data.choiceReasons) {
                  <ul>
                    @for (reason of clientTaskHistoryItem.data.choiceReasons; track reason) {
                      <li>
                        @switch (reason) {
                          @case (verificationReasons.other) {
                            {{ reason | capitalize }}@if (clientTaskHistoryItem.data.choiceOtherReasonNote) {
                            :
                          }
                          @if (clientTaskHistoryItem.data.choiceOtherReasonNote) {
                            {{ clientTaskHistoryItem.data.choiceOtherReasonNote }}
                          }
                        }
                        @case (verificationReasons.specialityReferral) {
                          {{ reason | capitalize }}@if (clientTaskHistoryItem.data.choiceSpecialityReferralSpeciality) {
                          :
                        }
                        @if (clientTaskHistoryItem.data.choiceSpecialityReferralSpeciality) {
                          {{ clientTaskHistoryItem.data.choiceSpecialityReferralSpeciality }}
                        }
                      }
                      @default {
                        {{ reason | capitalize }}
                      }
                    }
                  </li>
                }
              </ul>
            }
          </dd>
          @if (referralDates) {
            <div>Referral Date(s): {{ referralDates | joinList }}</div>
          }
          <div>Consult note task created by user: {{ clientTaskHistoryItem.data.collectConsultNote ? 'Yes' : 'No' }}</div>
        </dl>
      </div>
    }
    @case (clientReferralTaskChoices.no) {
      <div class="ps-3">
        <div>Rejection Level: {{ referralRejectedReason | capitalize }}</div>
        <app-client-task-history-item-rejected-prescriptions
          [clientTaskHistoryItem]="clientTaskHistoryItem" />
      </div>
    }
  }
</div>
}

@if (isConsultNoteTask) {
  <div>
    @switch (clientTaskHistoryItem.data.choice) {
      @case (clientConsultNoteTaskChoices.yes) {
        <div class="ps-3">
          @if (consultNoteDates) {
            <div>Consult Note Date(s): {{ consultNoteDates | joinList }}</div>
          }
          @if (verifiedPrescriptionIds) {
            <div class="mt-3">Verified Prescriptions: {{ clientTaskHistoryItem.data.verifiedPrescriptionIds | joinList }}</div>
          }
          <app-client-task-history-item-rejected-prescriptions
            [clientTaskHistoryItem]="clientTaskHistoryItem" />
        </div>
      }
      @case (clientConsultNoteTaskChoices.no) {
        <div class="ps-3">
          <div>Rejection Level: {{ consultNoteRejectedReason | capitalize }}</div>
          <app-client-task-history-item-rejected-prescriptions
            [clientTaskHistoryItem]="clientTaskHistoryItem" />
        </div>
      }
      @case (clientConsultNoteTaskChoices.assignBackToPar8o) {
        <div class="ps-3">
          <app-client-task-history-item-rejected-prescriptions
            [clientTaskHistoryItem]="clientTaskHistoryItem" />
        </div>
      }
      @case (clientConsultNoteTaskChoices.prescriberIsCeProvider) {
        <div class="ps-3">
          <app-client-task-history-item-rejected-prescriptions
            [clientTaskHistoryItem]="clientTaskHistoryItem" />
        </div>
      }
    }
  </div>
}

@if (isPrescriberTask) {
  <div>
    @switch (clientTaskHistoryItem.data.choice) {
      @case (clientPrescriberTaskChoices.yes) {
        <div class="ps-3">
          @if (verifiedPrescriptionIds) {
            <div class="mt-3">Verified Prescriptions: {{ clientTaskHistoryItem.data.verifiedPrescriptionIds | joinList }}</div>
          }
        </div>
      }
      @case (clientPrescriberTaskChoices.no) {
        <div class="ps-3">
          <app-client-task-history-item-rejected-prescriptions
            [clientTaskHistoryItem]="clientTaskHistoryItem" />
        </div>
      }
    }
  </div>
}

@if (hasAdditionDetails) {
  <div class="mt-3 ps-3">Additional Details: {{ additionalDetails }}</div>
}
</app-client-task-history-item-body>
